var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 28H5.6C5.17565 28 4.76869 27.8314 4.46863 27.5314C4.16857 27.2313 4 26.8243 4 26.4V5.6C4 5.17565 4.16857 4.76869 4.46863 4.46863C4.76869 4.16857 5.17565 4 5.6 4H16.9376C17.3616 4.00009 17.7683 4.16851 18.0683 4.46827L24.3317 10.7317C24.6315 11.0317 24.7999 11.4384 24.8 11.8624V16.8",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7998 12H18.3998C17.9755 12 17.5685 11.8314 17.2684 11.5314C16.9684 11.2313 16.7998 10.8243 16.7998 10.4V4",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28V20",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H12.8C13.4365 20 14.047 20.2529 14.4971 20.7029C14.9471 21.153 15.2 21.7635 15.2 22.4C15.2 23.0365 14.9471 23.647 14.4971 24.0971C14.047 24.5471 13.4365 24.8 12.8 24.8H12",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3999 28V20L21.5999 28V20",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1998 24.8H27.9998V26.4C27.9998 26.8243 27.8312 27.2313 27.5312 27.5314C27.2311 27.8314 26.8242 28 26.3998 28C25.9755 28 25.5685 27.8314 25.2684 27.5314C24.9684 27.2313 24.7998 26.8243 24.7998 26.4V21.6C24.7998 21.1757 24.9684 20.7687 25.2684 20.4686C25.5685 20.1686 25.9755 20 26.3998 20H27.9998",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.6dfda39d6218a336d4e50efd819e496a.svg";
export { ForwardRef as ReactComponent };